import { FaccettaHash } from '../../../search/faccette/faccetta-hash';
import { SearchCriteria } from '../search-criteria';

export class SearchRequest {
  includeDocuments: boolean;
  includePratiche: boolean;
  includeFascicoli: boolean;
  includiFaccette: boolean = true;
  nomeCampoOrdinamento: string;
  asc: boolean;
  searchCriteria: SearchCriteria;
  soloPratiche: boolean;
  fromResult: number;
  size: number;
  faccetteDaApplicare: FaccettaHash = {};
  constructor() {
    this.searchCriteria = new SearchCriteria();
  };

}

